import { useEffect, useState } from "react";
import { _LoanTimeTerm, _PayrollEntity, _single, _ThirdLoanEntity } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import { SelectLoanTimeConstants } from "../QuotaTimeTerm/componentes/SelectSelectLoanTimeConstants";

export const LoanTimeTerm = () => {
    const { instance, setLista, setBean, bean, lista, handleChange } = useDataBean(_LoanTimeTerm);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const head = [
        { title: 'ID', property: 'IDLoanTimeTerm', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Unidades de Tiempo', property: 'UnitTypeName', visible: true },
        { title: 'Unidades de Conversión', property: 'UnitValue', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        instance.getLoanTimeTermCatalog(null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const updateIten = () => {
        instance.updateLoanTimeTerm(bean).then(
            (resp) => {
                getLista()
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteItem = () => {
        instance.deleteLoanTimeTerm(bean.IDLoanTimeTerm).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => {
                console.log(err)
            }
        );
    }

    const create = () => {
        setBean({
            Enabled: false,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, "name": "Agregar Tipo de Plazo para Créditos" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Tipo de Plazo para Créditos" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Tipo de Plazo para Créditos` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Tipos de Plazos para Créditos" >
            <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />


            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar {bean.IDThirdLoanEntity} - {bean.Name}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={updateIten}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Nombre</label>
                            <input type="text" className="form-control" name="Name" value={bean.Name} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <SelectLoanTimeConstants idSelector={bean.UnitType} onChange={(e) => { setBean({ ...bean, "UnitType": e }) }} label="Unidades de Tiempo" />
                        </div>
                        <div className="col-md-6">
                            <label>Unidades de Conversión</label>
                            <input type="text" name="UnitValue" className="form-control" value={bean.UnitValue} onChange={handleChange} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                        </div>
                    </div>
                </Modal>
            </div>

        </BasicPage>
    )
}